<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">BÁO CÁO THỐNG KÊ VỀ GIÁO DỤC NGƯỜI KHUYẾT TẬT&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button
          nz-button
          class="flex items-center justify-center"
          nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom"
          nz-tooltip
          (click)="exportExcel()"
          >
          <i
            nz-icon
            nzType="file-excel"
            nzTheme="twotone"
            ></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button
          nz-button
          class="flex items-center justify-center"
          (click)="exportExcel()"
        >
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button
          nz-button
          class="flex items-center justify-center"
          (click)="exportExcel()"
          >
        <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Năm</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}" nzPlaceHolder="Nhập năm"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Tỉnh thành</nz-form-label>
          <asc-autocomplete  [ascModel]="DisProvincesControl"
            (ascModelChange)="changeDisProvincesACFn($event)" placeholder="Chọn tỉnh thành..."
            [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Quận huyện</nz-form-label>
          <asc-autocomplete  [ascModel]="DistrictControl"
            (ascModelChange)="changeDistrictACFn($event)" placeholder="Chọn quận huyện..."
            [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Phường xã</nz-form-label>
          <asc-autocomplete  [ascModel]="DisWardControl"
            (ascModelChange)="changeDisWardACFn($event)" placeholder="Chọn Phường xã..."
            [getListAC]="getDisWardACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <ng-container *ngIf="!isCollapse">
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" >Họ tên</nz-form-label>
            <input nz-input placeholder="Nhập họ tên" [(ngModel)]="commonFilter.FullName" [ngModelOptions]="{standalone: true}" />
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Giới tính</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="-1">Tất cả</label>
                <label nz-radio [nzValue]="1">Nam</label>
                <label nz-radio [nzValue]="0">Nữ</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Giấy chứng nhận khuyết tật</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-radio-group [(ngModel)]="commonFilter.DisDisabilityCertificateType" [ngModelOptions]="{standalone: true}">
                <label nz-radio [nzValue]="-1">Tất cả</label>
                <label nz-radio [nzValue]="2">Không</label>
                <label nz-radio [nzValue]="1">Có</label>
                <label nz-radio [nzValue]="3">Nghi ngờ khuyết tật</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" >Dạng tật</nz-form-label>
            <asc-autocomplete  [ascModel]="disTypeOfDisabilitysControl"
                (ascModelChange)="changeDisTypeOfDisabilitysACFn($event)" placeholder="Chọn dạng tật..."
                [getListAC]="getDisTypeOfDisabilitysACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" >Mức độ khuyết tật</nz-form-label>
            <asc-autocomplete  [ascModel]="LevelControl"
                (ascModelChange)="changeLevelACFn($event)" placeholder="Chọn mức độ khuyết tật..."
                [getListAC]="getLevelACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" >Tình trạng giáo dục</nz-form-label>
            <asc-autocomplete  [ascModel]="caDisEducationalStatusesControl"
                (ascModelChange)="changeCaDisEducationalStatuses($event)" placeholder="Chọn tình trạng giáo dục..."
                [getListAC]="getCaDisEducationalStatusessACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" >Phương thức giáo dục</nz-form-label>
            <asc-autocomplete [ascModel]="disModesOfEducationControl"
                (ascModelChange)="changeDisModesOfEducation($event)" placeholder="Chọn phương thức giáo dục..."
                [getListAC]="getDisModesOfEducationACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" >Hình thức giáo dục</nz-form-label>
            <asc-autocomplete  [ascModel]="disStudyModeControl"
                (ascModelChange)="changeDisStudyMode($event)" placeholder="Chọn Hình thức giáo dục..."
                [getListAC]="getDisStudyModeACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" >Nhu cầu hỗ trợ</nz-form-label>
            <asc-autocomplete  [ascModel]="caDisNeedOfDisabilitysControl"
                (ascModelChange)="changeCaDisNeedOfDisabilitys($event)" placeholder="Chọn nhu cầu hỗ trợ..."
                [getListAC]="getCaDisNeedOfDisabilitysACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
      </ng-container>
      <div nz-col *ngIf="isCollapse" nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">i</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'" nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()"><i nz-icon nzType="search"
              nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table #Table
      [nzShowTotal]="rangeTemplate"
      nzBordered
      nzShowSizeChanger
      nzSize="small"
      class="w-full absolute"
      [nzData]="dataTable"
      [nzFrontPagination]="false"
      [nzTotal]="Total"
      [nzPageSize]="pageSize"
      [nzScroll]="{ y: height + 'px'}"
      [nzPageIndex]="pageIndex"
      [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)"
      (nzPageSizeChange)="pageSizeEvent($event)"
      [nzLoading]="loading"
      [nzWidthConfig]="widthConfig"
      >
      <thead>
        <tr #pageHeaderTable>
            <th class="col-head" rowspan="3" colspan="1" nzLeft>
                STT
            </th>
            <th class="col-head" rowspan="3" colspan="1" nzLeft>
                Họ và tên
            </th>
            <th class="col-head text-center" colspan="2">
                Giới tính
            </th>
            <th class="col-head text-center" rowspan="3" colspan="1">
                Năm sinh
            </th>
            <th class="col-head text-center" rowspan="3" colspan="1">
                Giấy xác nhận KT
            </th>
            <th class="col-head text-center" [colspan]="dataDkt.length">
                dạng tật
            </th>
            <th class="col-head text-center" [colspan]="dataMdkt.length">
                Mức độ KT
            </th>
            <th class="col-head text-center" [colspan]="dataTtgd.length">
                Tình trạng giáo dục
            </th>
            <th class="col-head text-center" [colspan]="dataPtgd.length">
                Phương thức giáo dục
            </th>
            <th class="col-head text-center" [colspan]="dataHth.length">
                Hình thức giáo dục
            </th>
            <th class="col-head text-center" [colspan]="dataNcht.length">
                Nhu cầu hỗ trợ
            </th>
            <th class="col-head text-center" colspan="6">
                Giáo viên đang dạy/chủ nhiệm(Đối với MN và phổ thông)
            </th>
            <th class="col-head text-center" colspan="5">
                CMHS/Người đỡ đầu
            </th>
            <th class="col-head text-center" rowspan="3" colspan="1">
                điều kiện kinh tế gia đình
            </th>
            <th class="col-head text-center" rowspan="3" colspan="1">
                Ghi chú
            </th>
        </tr>
        <tr #pageHeaderTable2>
            <th class="col-head text-center" rowspan="2" colspan="1">Nam</th>
            <th class="col-head text-center" rowspan="2" colspan="1">Nữ</th>
            <ng-container *ngFor="let dkt of dataDkt">
              <th class="col-head text-center" rowspan="2" colspan="1">{{ dkt.name }}</th>
            </ng-container>
            <ng-container *ngFor="let dkt of dataMdkt">
              <th class="col-head text-center" rowspan="2" colspan="1">{{ dkt.levelName }}</th>
            </ng-container>
            <ng-container *ngFor="let ttgd of dataTtgd">
              <th class="col-head text-center" rowspan="2" colspan="1">{{ ttgd.name }}</th>
            </ng-container>
            <ng-container *ngFor="let ptgd of dataPtgd">
              <th class="col-head text-center" rowspan="2" colspan="1">{{ ptgd.name }}</th>
            </ng-container>
            <ng-container *ngFor="let hth of dataHth">
              <th class="col-head text-center" rowspan="2" colspan="1">{{ hth.name }}</th>
            </ng-container>
            <ng-container *ngFor="let ncht of dataNcht">
              <th class="col-head text-center" rowspan="2" colspan="1">{{ ncht.name }}</th>
            </ng-container>
            <th class="col-head text-center" rowspan="2" colspan="1" nzWidth="200px" style="min-width:200px">Họ và tên</th>
            <th class="col-head text-center" rowspan="2" colspan="1">Trình độ</th>
            <th class="col-head text-center" rowspan="2" colspan="1">Chuyên môn</th>
            <th class="col-head text-center" rowspan="1" colspan="3">Bồi dưỡng về GDĐB</th>
            <th class="col-head text-center" rowspan="2" colspan="1" nzWidth="200px" style="width:200px">Họ và tên</th>
            <th class="col-head text-center" rowspan="2" colspan="1">Trình độ</th>
            <th class="col-head text-center" rowspan="1" colspan="3">Bồi dưỡng về GDĐB</th>
        </tr>
        <tr #pageHeaderTable3>
            <th class="col-head text-center" colspan="1">Chứng chỉ</th>
            <th class="col-head text-center" colspan="1">Chứng nhận</th>
            <th class="col-head text-center" colspan="1">Chưa BD</th>
            <th class="col-head text-center" colspan="1">Chứng chỉ</th>
            <th class="col-head text-center" colspan="1">Chứng nhận</th>
            <th class="col-head text-center" colspan="1">Chưa BD</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of Table.data; let i = index">
        <td nzLeft>
          {{ i + 1 + (pageIndex-1)*pageSize }}
        </td>
        <td nzLeft nzAlign="left">
          {{ data.fullName}}
        </td>
        <td  nzAlign="center">
          <!-- <label nz-checkbox [ngModel]="data.gender === 1? true : false" [nzDisabled]="true" ></label> -->
          <i nz-icon *ngIf="data.gender === 1" nzType="close" nzTheme="outline"></i>
        </td>
        <td nzAlign="center">
          <!-- <label nz-checkbox [ngModel]="data.gender === 0? true : false" [nzDisabled]="true"></label> -->
          <i nz-icon *ngIf="data.gender === 0" nzType="close" nzTheme="outline"></i>
        </td>
        <td nzAlign="left">
          {{ data.yearDateOfBirth }}
        </td>
        <td nzAlign="left">
          {{ data.disDisabilityCertificateType | disDisabilityCertificateType }}
        </td>
        <ng-container *ngFor="let dkt of dataDkt">
          <td nzAlign="center">
            <!-- <label nz-checkbox [ngModel]="data.typeOfDisabilityIds === dkt.id? true : false" [nzDisabled]="true"></label> -->
            <ng-container *ngFor="let item of data.typeOfDisabilityIds">
              <i nz-icon *ngIf="item === dkt.id" nzType="close" nzTheme="outline"></i>
            </ng-container>
          </td>
        </ng-container>
        <ng-container *ngFor="let mdkt of dataMdkt">
          <td nzAlign="center">
            <!-- <label nz-checkbox [ngModel]="data.disLevelId === mdkt.id? true : false" [nzDisabled]="true"></label> -->
            <i nz-icon *ngIf="data.disLevelId === mdkt.id" nzType="close" nzTheme="outline"></i>
          </td>
        </ng-container>
        <ng-container *ngFor="let ttgd of dataTtgd">
          <td nzAlign="center">
            <!-- <label nz-checkbox [ngModel]="data.educationalStatusId === ttgd.id? true : false" [nzDisabled]="true"></label> -->
            <i nz-icon *ngIf="data.educationalStatusId === ttgd.id" nzType="close" nzTheme="outline"></i>
          </td>
        </ng-container>
        <ng-container *ngFor="let ptgd of dataPtgd">
          <td nzAlign="center">
            <!-- <label nz-checkbox [ngModel]="data.modesOfEducationId === ptgd.id? true : false" [nzDisabled]="true"></label> -->
            <i nz-icon *ngIf="data.modesOfEducationId === ptgd.id" nzType="close" nzTheme="outline"></i>
          </td>
        </ng-container>
        <ng-container *ngFor="let hth of dataHth">
          <td nzAlign="center">
            <!-- <label nz-checkbox [ngModel]="data.studyModeId === hth.id? true : false" [nzDisabled]="true"></label> -->
            <i nz-icon *ngIf="data.studyModeId === hth.id" nzType="close" nzTheme="outline"></i>
          </td>
        </ng-container>
        <ng-container *ngFor="let ncht of dataNcht">
          <td nzAlign="center">
            <!-- <label nz-checkbox [ngModel]="data.needOfDisabilityId === ncht.id? true : false" [nzDisabled]="true"></label> -->
            <i nz-icon *ngIf="data.needOfDisabilityId === ncht.id" nzType="close" nzTheme="outline"></i>
          </td>
        </ng-container>
        <td nzAlign="left">
          {{ data.staffFullName }}
        </td>
        <td nzAlign="left">
          {{ data.staffQualificationName }}
        </td>
        <td nzAlign="left">
          {{ data.staffMajorName }}
        </td>
        <td nzAlign="center">
          <i nz-icon *ngIf="data.staffLicensed" nzType="close" nzTheme="outline"></i>
        </td>
        <td nzAlign="center">
          <i nz-icon *ngIf="data.staffCertificated" nzType="close" nzTheme="outline"></i>
        </td>
        <td nzAlign="center">
          <i nz-icon *ngIf="data.staffUnfostered" nzType="close" nzTheme="outline"></i>
        </td>
        <!-- người đỡ đầu -->
        <td nzAlign="left">
          {{ data.tutorName }}
        </td>
        <td nzAlign="left">
          {{ data.tutorEducationLevelName }}
        </td>
        <td nzAlign="center">
          {{ data.TutorLicensed }}
          <i nz-icon *ngIf="data.tutorLicensed" nzType="close" nzTheme="outline"></i>
        </td>
        <td nzAlign="center">
          <i nz-icon *ngIf="data.tutorCertificated" nzType="close" nzTheme="outline"></i>
        </td>
        <td nzAlign="center">
          <i nz-icon *ngIf="data.tutorUnfostered" nzType="close" nzTheme="outline"></i>
        </td>
        <td nzAlign="left">
          {{ data.livingConditionName }}
        </td>
        <td nzAlign="left">

        </td>
      </tr>
    </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
